// extracted by mini-css-extract-plugin
module.exports = {"TitleWithBorder":"TitleWithBorder_TitleWithBorder__QkwvG"};